import localForage from 'localforage';
import { apiUrl, tokenUrl, refreshParameterBody, openApiUrl, loginUrl } from '../config';
import { setTokensWithDispatch, refreshTokens } from '../store/users/actions';
import { Token } from '../store/users/types';

const formatMyList = async () => {
  /* REMOVE AFTER everyone migrates to 1.11.0 */
  let visitedPlaces: any;
  let bucketList: any;
  [visitedPlaces, bucketList] = await Promise.all([
    localForage.getItem('visitedPlaces'),
    localForage.getItem('bucketList')
  ]);
  const newObject = {};
  if (visitedPlaces) {
    Object.keys(visitedPlaces).forEach((item: string) => {
      const isFavorite = visitedPlaces[item].tags.indexOf('favorites') >= 0;
      const newTags = isFavorite ? ['favorites', 'visited'] : ['visited'];
      newObject[item] = {
        ...visitedPlaces[item],
        tags: newTags,
      };
    });
    await localForage.removeItem('visitedPlaces')
  }
  if (bucketList) {
    Object.keys(bucketList).forEach((item: string) => {
      if (newObject[item]) {
        newObject[item] = {
          ...newObject[item],
          tags: ['visited', 'bucket']
        }
        return;
      }
      newObject[item] = {
        ...bucketList[item],
        tags: ['bucket'],
      };
    });
    await localForage.removeItem('bucketList')
  }
  if (visitedPlaces || bucketList) {
    await localForage.setItem('myList', newObject);
  }
  // await localForage.setItem('myList', '');
  /* REMOVE AFTER everyone migrates to 1.11.0 */
}
const validUrl = (str: string) => {
  try {
    new URL(str);
    return true;
  } catch (e) {
    return false;
  }
}

// const getQueryByVariable = (queryString: string, variable: string) => {
//   const query = queryString.substring(1);
//   const vars = query.split('&');
//   for (var i = 0; i < vars.length; i++) {
//     const pair = vars[i].split('=');
//     if (decodeURIComponent(pair[0]) === variable) {
//       return decodeURIComponent(pair[1]);
//     }
//   }
//   console.log('Query variable %s not found', variable);
// }

const getQueryByVariable = (queryString: string, variable: string) => {
  const params = queryString.split('&');
  const match:string = params.find(param => (decodeURIComponent(param).includes(`${variable}=`))) || '';

  return decodeURIComponent(match).split('=')[1];
}

const getUsername = (token: string) => {
  if (!token) {
    return null;
  }
  const data = token.split('.')[1];
  const username = JSON.parse(atob(data))['cognito:username'];
  return username
}

const getMyListFromLocal = async () => {
  const res: any = await localForage.getItem('myList');
  let newObjectWithCode = res;
  if (Object.keys(res).length > 0 && Object.keys(res)[0].length > 15) {
    newObjectWithCode = {};
    Object.keys(res).forEach((item) => {
      const { parkCode } = res[item];
      newObjectWithCode[parkCode] = res[item];
    });
    await localForage.setItem('myList', newObjectWithCode);
  }
  return newObjectWithCode;
}

const authFetch = async (tokens: Token, params: any, dispatch?: any) => {
  const todayTime = new Date().getTime();
  let newToken: any = tokens;
  if (!newToken || !newToken.refresh_token) {
    newToken = await localForage.getItem('tokens');
  }
  if (newToken && newToken.refresh_token) {
    if (!newToken.expired_at || newToken.expired_at < todayTime) {
      const result = await fetch(tokenUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `${refreshParameterBody}&refresh_token=${newToken.refresh_token}`,
      });
      if (result.status !== 200) {
        await localForage.removeItem('tokens');
        window.location.href = loginUrl;
        return;
      }
      newToken = {
        ...newToken,
        ...await result.json(),
        expired_at: new Date(todayTime).setTime(todayTime + (60*60*1000))
      };
      await setTokensWithDispatch(newToken, dispatch);
      await localForage.setItem('tokens', newToken);
    }
  }
  if (!newToken || !newToken.id_token) {
    return { error: 'Please sign in.'};
  }
  const { url, param } = params;
  const result = await fetch(`${apiUrl}/${url}`, {
    ...param,
    headers: {
      ...param.headers,
      Authorization: `Bearer ${newToken.id_token}`,
    },
  });
  return result;
};

const unauthFetch = async (url: string, params: any) => {
  const result = await fetch(`${openApiUrl}/${url}`, {
    ...params,
  });
  return result;
};

export {
  unauthFetch,
  authFetch,
  formatMyList,
  getMyListFromLocal,
  getQueryByVariable,
  validUrl,
  getUsername,
};
